import React from "react";
import { FlatButton, TextField } from "material-ui";

import BaseOverlay from "./base.jsx";

const styles = {
  container: {
    marginTop: "1em"
  },
  selectContainer: {
    marginTop: "1em"
  }
};

class BulkDeleteOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deleteConfirmation: null
    };

    this.delete = this.delete.bind(this);
  }

  delete() {
    this.props.onDelete();
  }

  render() {
    const { submitting, items, onClose, itemName } = this.props;
    const itemsLength = items.length;

    return (
      <BaseOverlay
        onRequestClose={onClose}
        hideTitleAndFooterBorders={true}
        showCloseButton={true}
        useMuiDefaultStyle={true}
        disableBackgroundDismiss
        actions={[
          <FlatButton label="Cancel" onClick={onClose} />,
          <FlatButton
            primary={true}
            disabled={
              submitting ||
              this.state.deleteConfirmation !== itemsLength.toString()
            }
            label={submitting ? "Deleting..." : "Delete"}
            onClick={this.delete}
          />
        ]}
      >
        <h2>
          Delete {itemsLength} {itemName}
        </h2>
        <div style={styles.container}>
          <p>
            Are you sure you want to delete {itemsLength} {itemName}?
          </p>

          <p>This action cannot be undone.</p>

          <p>
            Type `{itemsLength}` below to confirm that you are deleting{" "}
            {itemsLength} {itemName}.
          </p>
          <TextField
            value={this.state.deleteConfirmation}
            floatingLabelText="Confirmation"
            floatingLabelFixed={true}
            onChange={e =>
              this.setState({ deleteConfirmation: e.target.value })
            }
          />
        </div>
      </BaseOverlay>
    );
  }
}

export default BulkDeleteOverlay;



// WEBPACK FOOTER //
// ./src/app/components/partials/overlays/bulk-delete-overlay.jsx